<div class="opt-dialog-container">
  <div class="header">
    <h1 mat-dialog-title>{{ title }}</h1>
  </div>

  <div mat-dialog-content>
    <span class="body">{{ body }}</span>
  </div>

  <div class="footer">
    <button mat-flat-button (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onConfirm()">
      Confirm
    </button>
  </div>
</div>
